import * as React from "react";
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Link,
  LinkProps,
  useDisclosure,
} from "@chakra-ui/react";
import { Link as RouterLink, NavLink as RouterNavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { ColorModeSwitcher } from "ColorModeSwitcher";
import siteConfig from "configs/site-config";
import { CONTENT_WIDTH, linkProps } from "components/page";

interface NavItemProps extends LinkProps {
  name: string;
  path: string;
  external?: boolean;
}

const NavItem = ({ name, path, external, ...props }: NavItemProps) => (
  <Link
    {...linkProps(path, external, RouterNavLink)}
    px={3}
    py={1.5}
    fontSize="sm"
    color="muted"
    borderRadius="full"
    _hover={{ color: "fg" }}
    _activeLink={{ color: "fg", bg: "accentSoft" }}
    {...props}
  >
    {name}
  </Link>
);

export default function TopNav() {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={10}
      bg="bgGlass"
      borderBottom="1px solid"
      borderColor="line"
      sx={{
        backdropFilter: "saturate(180%) blur(12px)",
        WebkitBackdropFilter: "saturate(180%) blur(12px)",
      }}
    >
      <Flex maxW={CONTENT_WIDTH} mx="auto" px={6} h={16} align="center" justify="space-between">
        <Link
          as={RouterLink}
          to="/"
          onClick={onClose}
          fontFamily="heading"
          fontSize="2xl"
          lineHeight={1}
          _hover={{ color: "accent" }}
        >
          {siteConfig.author.name}
        </Link>

        <HStack spacing={1}>
          <HStack as="nav" aria-label="Site" spacing={1} display={{ base: "none", md: "flex" }}>
            {siteConfig.pages.map((page) => (
              <NavItem key={page.path} {...page} />
            ))}
          </HStack>
          <ColorModeSwitcher />
          <IconButton
            display={{ md: "none" }}
            size="sm"
            variant="ghost"
            borderRadius="full"
            fontSize="lg"
            color="muted"
            _hover={{ color: "fg", bg: "accentSoft" }}
            icon={isOpen ? <FiX /> : <FiMenu />}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            onClick={onToggle}
          />
        </HStack>
      </Flex>

      {isOpen && (
        <Box as="nav" aria-label="Site" display={{ md: "none" }} px={3} pb={4}>
          {siteConfig.pages.map((page) => (
            <NavItem
              key={page.path}
              {...page}
              onClick={onClose}
              display="block"
              py={2.5}
              fontSize="md"
              borderRadius="lg"
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
